import React, { useRef, useState } from "react";
import {
  useMotionValueEvent,
  useReducedMotion,
  useScroll,
} from "framer-motion";
import styles from "./lifecycle.module.css";
import { Section, SectionIntro } from "../../../../COMPONENTS/UI";
import { lifecycle } from "../../../../CONTENT/home";

const Lifecycle = () => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const [progress, setProgress] = useState(reduce ? 1 : 0);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 65%", "end 60%"],
  });
  useMotionValueEvent(scrollYProgress, "change", (v) =>
    setProgress(reduce ? 1 : v)
  );

  const reached = (i) => progress >= (i + 0.5) / lifecycle.length - 0.001;

  return (
    <Section tone="cloud" id="how-it-works" labelledBy="lifecycle-title">
      <SectionIntro
        id="lifecycle-title"
        eyebrow="How KUR works"
        title="From the first feasibility call to closeout, one team."
        lead="Every study moves through the same seven stages, run centrally so quality and speed do not depend on which site is enrolling."
      />

      <div className={styles.track} ref={ref}>
        <div className={styles.rail} aria-hidden="true">
          <span className={styles.fill} style={{ "--p": progress }} />
        </div>
        <ol className={styles.steps}>
          {lifecycle.map((step, i) => (
            <li
              key={step.title}
              className={styles.step}
              data-reached={reached(i)}
            >
              <span className={styles.dot} aria-hidden="true">
                {i + 1}
              </span>
              <h3 className={styles.stepTitle}>{step.title}</h3>
              <p className={styles.stepText}>{step.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </Section>
  );
};

export default Lifecycle;
